<template>
  <model-crud
    :model="model"
    :fields="fields"
    :editable="false"
    :deletable="false"
    default-order="actionDate"
    :default-order-asc="false"
  />
</template>

<script>
import ModelCrud from '@/components/ModelCrud'
import Access from '@/models/Access'

export default {
  data () {
    return {
      model: Access,
      fields: {
        ipAddress: {
          label: this.$t('headers.ipAddress')
        },
        username: {
          label: this.$t('headers.user')
        },
        actionDate: {
          label: this.$t('headers.date'),
          type: 'date'
        },
        actionType: {
          label: this.$t('headers.actionType')
        }
      }
    }
  },
  components: {
    ModelCrud
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// Accesses.vue?a939243a